import { createPortal } from 'react-dom';
export var Portal = function Portal(_ref) {
  var children = _ref.children;
  var genplan = document.getElementById('flat-svg');
  return /*#__PURE__*/createPortal(children, genplan);
};